import type { ClinicianFacingUserInfoT } from '@lotushealth/lotushealth_js_sdk/schemas';

import type { PatientNavigatorItemData } from '@/features/patient-navigator';

export function toPatientNavigatorItems(
  patients: ClinicianFacingUserInfoT[]
): PatientNavigatorItemData[] {
  return patients.map((patient) => ({
    ...extractPolicyFields(patient),
    userId: patient.user_id,
    fullName: patient.full_name,
    oldestRequestAt: patient.oldest_request_at,
    urgentCount: patient.urgent_count,
    routineCount: patient.routine_count,
    unreadCount: patient.unread_count,
    viewerCount: patient.viewer_count,
  }));
}

function extractPolicyFields(
  patient: ClinicianFacingUserInfoT
): Pick<
  PatientNavigatorItemData,
  'policyRelationship' | 'clinicianLicensedStates' | 'patientCurrentState' | 'patientPracticeAreas'
> {
  const { policy_result: policyResult } = patient;
  if (typeof policyResult.debug === 'string') {
    return {
      policyRelationship: policyResult.relationship,
      clinicianLicensedStates: [],
      patientCurrentState: null,
      patientPracticeAreas: [],
    };
  }

  return {
    policyRelationship: policyResult.relationship,
    clinicianLicensedStates: policyResult.debug.you.tags.us_states ?? [],
    patientCurrentState: policyResult.debug.patient.tags.us_states?.[0] ?? null,
    patientPracticeAreas: policyResult.debug.patient.tags.practice_areas ?? [],
  };
}
